import { toNumber } from './obracunFields';

const WOLT_WEEKS = new Set(['w1', 'w2']);

export function normalizeWeekAndPlatform(week, platform) {
  const weekStr = String(week).trim().toLowerCase();
  if (WOLT_WEEKS.has(weekStr)) {
    return { week: weekStr, platform: 'wolt' };
  }

  const weekNum = Number(week);
  if (!Number.isInteger(weekNum) || weekNum < 1 || weekNum > 5) {
    return null;
  }

  return {
    week: weekNum,
    platform: platform === 'wolt' ? 'wolt' : 'glovo',
  };
}

export function validateEarningRecord(record) {
  const normalized = normalizeWeekAndPlatform(record.week, record.platform);
  if (!normalized) return { valid: false, reason: 'Neispravan week. Dozvoljeno: 1-5, w1, w2.' };
  if (!record.userId || !record.firmId) {
    return { valid: false, reason: 'Nedostaje userId ili firmId.' };
  }
  if (!record.year || !record.month) {
    return { valid: false, reason: 'Nedostaje godina ili mjesec.' };
  }
  return {
    valid: true,
    payload: {
      ...record,
      week: normalized.week,
      platform: normalized.platform,
      amount: toNumber(record.amount),
    },
  };
}

